// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-loader2',
    // #endregion
    // #region Props
    props: {
        isActive: {
            type: Boolean,
            required: false,
            default: true
        },
        mode: {
            type: String,
            required: false,
            default: "default",
        },
        size: {
            type: String,
            required: false,
            default: '50px'
        },
        sizeMode: {
            type: String,
            required: false,
            default: ''
        },
        class: {
            type: String,
            required: false,
            default: 'bg-white bg-opacity-75'
        },
        color: {
            type: String,
            required: false,
            default: 'primary'
        },
    },
    // #endregion
});
// #endregion
